import { useState } from 'react';

/**
 * Logo de un cliente con fuente de respaldo: si la primera no responde se
 * prueba la siguiente y, si ninguna funciona, la imagen desaparece y la
 * tarjeta se queda solo con el nombre (nunca un icono roto).
 */
const sourcesFor = (domain) => [
  `https://www.google.com/s2/favicons?sz=128&domain=${domain}`,
  `https://icons.duckduckgo.com/ip3/${domain}.ico`,
];

export default function ClientLogo({ domain, name, className = 'max-h-9 max-w-[70%] w-auto object-contain' }) {
  const [attempt, setAttempt] = useState(0);
  const sources = sourcesFor(domain);

  if (attempt >= sources.length) return null;

  return (
    <img
      src={sources[attempt]}
      alt={name}
      className={className}
      loading="lazy"
      decoding="async"
      onError={() => setAttempt((a) => a + 1)}
    />
  );
}